import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'components/styledComponents/Button';
import Joi from 'joi';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { openForgot } from 'redux/actions/modalActions';
import { useApi } from '../../hooks/useApi';
import { Spinner } from '../ui';
import { CheckboxInput } from './CheckboxInput';
import { TextInput } from './TextInput';

export const InFormLogin = () => {
    const api = useApi();
    const dispatch = useDispatch();
    const { getValues, watch, setFocus } = useFormContext();
    const createAccount = watch('create_account', false);
    const [userFound, setUserFound] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showPasswort, setShowPasswort] = useState(false);

    const validateEmail = (email: string) => Joi.string().email({ tlds: false }).validate(email).error === undefined;

    const checkEmail = useCallback(() => {
        const email = getValues('email');
        if (validateEmail(email)) {
            setIsLoading(true);
            void api({
                url: 'login/guess',
                method: 'POST',
                data: { email },
                onBefore: () => setIsLoading(false),
                onSuccess: () => {
                    setUserFound(true);
                    // setFocus("password");
                },
                onFailure: () => {
                    setUserFound(false);
                },
                muted: true
            });
        }
    }, [getValues, document]);

    const debouncedChangeHandler = useCallback(debounce(checkEmail, 500), []);
    useEffect(() => debouncedChangeHandler(), []);

    return (
        <>
            <TextInput
                append={
                    <span className="input-group-text">
                        {isLoading ? <Spinner size="sm" /> : <FontAwesomeIcon icon={faEnvelope} />}
                    </span>
                }
                name="email"
                label="E-Mail Adresse *"
                onChange={debouncedChangeHandler}
            />

            {userFound ? (
                <div className="alert alert-success" role="alert">
                    <h4 className="alert-heading">Hurra!</h4>
                    <p>
                        Unter dieser E-Mail Adresse wurde bereits ein Sportision Account gefunden! Bitte gebe dein
                        Passwort ein oder klicke auf Passwort vergessen.
                    </p>
                    <hr />
                    <Button type="button" onClick={() => dispatch(openForgot())} variant="light">
                        Passwort vergessen
                    </Button>
                </div>
            ) : (
                <>
                    <TextInput name="name" label="Name *" />
                    <CheckboxInput name="create_account" label="Ich möchte einen Sportision Account erstellen" />
                </>
            )}
            {(createAccount || userFound) && (
                <TextInput type={showPasswort ? 'text' : 'password'} name="password" label="Passwort *" />
            )}
            {!userFound && createAccount && (
                <TextInput
                    type={showPasswort ? 'text' : 'password'}
                    name="password_confirmation"
                    label="Passwort wiederholen *"
                />
            )}
            {(createAccount || userFound) && (
                <CheckboxInput
                    name="show_password"
                    onChange={(e) => setShowPasswort(e.target.checked)}
                    label="Passwort in Klartext anzeigen"
                />
            )}
        </>
    );
};
